import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { CALL_API_URL } from '../Services/CallService';
import { useAuth } from './AuthContexts';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"

// create the context
export const DataContext = createContext();

export function useData() {
    return React.useContext(DataContext)
}
// create a provider for the context
export const DataProvider = ({ children }) => {
  // create state variables to store the data from the database
  // and a loading state to show a loading indicator
  const [data, setData] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const provider = useAuth();
  // use the useEffect hook to make a GET request to the database
  async function getEventData() {
    await axios
      .get(`${CALL_API_URL}/api/events`)
      .then((response) => {
        // update the data state with the response data
        setData(response.data);

        // set the loading state to false
        setLoading(false);
      })
      .catch((error) => {
        // handle the error
        console.error(error);
        setLoading(false);
      });
  }
  async function getUserCreds() {
    const querySnapshot = await getDocs(collection(db, "userDetails"));
    querySnapshot.forEach((user) => {
      if(provider.currentUser.email === user.data().email) {
        setUser(user.data())
      }
  });
  }

  async function refresh() {
    await axios
      .get(`${CALL_API_URL}/api/events`)
      .then((response) => {
        // update the data state with the response data
        setData(response.data);

        // set the loading state to false
        setLoading(false);
      })
      .catch((error) => {
        // handle the error
        console.error(error);
        setLoading(false);
      });
  }

  // return the provider and pass the state and a method to make
  // updates to the database
  return (
    <DataContext.Provider value={{ data, loading, setData, user, getUserCreds, refresh, getEventData}}>
      {!loading && children}
    </DataContext.Provider>
  );
};
